import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const settlementOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "产品名称",
            prop: "goodsName",
            type: 'input',
            search: true,
            span: 18
        },
        {
            label: "客户支付时间",
            prop: "payTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "推广人用户类型",
            prop: "clientType",
            type: "select",
            search: true,
            dicData: DIC.TAGS_CLIENT_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "推广人姓名/昵称",
            prop: "name",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "推广方式",
            prop: "promotionType",
            type: "select",
            search: true,
            dicData: DIC.PRODUCT_SHARE_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "推广员佣金",
            prop: "payMoney",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "结算方式",
            prop: "clearingType",
            type: "select",
            search: true,
            dicData: DIC.CLEARING_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
       
        {
            label: "结算状态",
            prop: "status",
            type: "select",
            search: true,
            dicData: DIC.CLEARING_STATUS_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "结算时间",
            prop: "clearingTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
    ]
};